import { Injectable } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  
  constructor(private oneSignal: OneSignal) {}

  /**
   * Affiche une notification locale pour un nouveau message
   */
  showLocalNotification(title: string, message: string, icon?: string) {
    // Vérifier si les notifications sont supportées
    if ('Notification' in window) {
      // Vérifier la permission
      if (Notification.permission === 'granted') {
        const notification = new Notification(title, {
          body: message,
          icon: icon || '/assets/img/logo.png', // Utiliser votre logo
          badge: '/assets/img/logo.png',
          tag: 'foundme-message', // Pour éviter les notifications multiples
          requireInteraction: false,
          silent: false
        });

        // Fermer automatiquement après 5 secondes
        setTimeout(() => {
          notification.close();
        }, 5000);

        // Gérer le clic sur la notification
        notification.onclick = () => {
          window.focus();
          notification.close();
        };

        return notification;
      }
    }
    return null;
  }

  /**
   * Envoie une notification push via OneSignal
   */
  async sendPushNotification(title: string, message: string, userId?: string) {
    try {
      // Si vous voulez envoyer une notification à un utilisateur spécifique
      if (userId && this.oneSignal) {
        // Note: Pour envoyer des notifications, vous devez utiliser l'API REST OneSignal
        // depuis votre backend. Ici nous montrons juste la structure
        // console.log('Sending push notification:', { title, message, userId });
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la notification push:', error);
    }
  }

  /**
   * Demande la permission pour les notifications
   */
  async requestPermission(): Promise<boolean> {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return false;
  }

  /**
   * Vérifie si les notifications sont autorisées
   */
  isNotificationEnabled(): boolean {
    return 'Notification' in window && Notification.permission === 'granted';
  }
}